import { Outlet, createFileRoute } from '@tanstack/react-router'
import { useTranslation } from 'react-i18next'
import { ExplorerShell } from '#/components/ontology/explorer-shell'
import { ontologySearchSchema } from '#/components/ontology/search'
import {
  canExploreOntology,
  ensureOntologyDoc,
} from '#/components/ontology/use-ontology-explorer'
import { RouteError } from '#/components/route-error'
import { RoutePending } from '#/components/route-pending'

export const Route = createFileRoute('/_authed/accounts/$accountId/ontology')({
  validateSearch: ontologySearchSchema,
  loaderDeps: ({ search }) => ({ v: search.v }),
  loader: async ({ context, params, deps }) => {
    await ensureOntologyDoc(context, params.accountId, deps.v)
  },
  pendingComponent: RoutePending,
  errorComponent: RouteError,
  component: OntologyLayout,
})

function OntologyLayout() {
  const { t } = useTranslation()
  const { me } = Route.useRouteContext()

  if (!canExploreOntology(me)) {
    return (
      <p className="p-8 text-sm text-muted-foreground">
        {t('internal.noAccess')}
      </p>
    )
  }

  return (
    <ExplorerShell>
      <Outlet />
    </ExplorerShell>
  )
}
